import React, { useState } from 'react';
import ScreenDetails from './screen-details';

import useWeeklyRosterContext from 'contexts/weekly-roster.context';

const KitchenShiftCard = ({ shift }: { shift: string }) => {
  const { addRosterFormData, setAddRosterFormData } = useWeeklyRosterContext();

  const [open, setOpen] = useState(true);
  const shiftDetails = addRosterFormData[0][
    shift as keyof (typeof addRosterFormData)[0]
  ] as string[];

  return (
    <div>
      <div className='flex items-center justify-between bg-[#F5F5F5] py-3 px-5 rounded-xl'>
        <p className='font-medium'>{shift?.toUpperCase()} SHIFT</p>
        <span
          className='bg-white text-center border border-[#E7E8E9] py-[5px] w-24 rounded-lg text-sm'
          role='button'
          onClick={() => setOpen(!open)}>
          {open ? 'Hide' : 'Show'}
        </span>
      </div>
      {open && (
        <div className='pt-8 bg-white'>
          <ScreenDetails
            staffs={shiftDetails}
            handleChange={(data) => {
              setAddRosterFormData({ ...addRosterFormData, [shift]: data });
            }}
          />
        </div>
      )}
    </div>
  );
};

export default KitchenShiftCard;
